module.exports = __webpack_public_path__ + "static/waa-6cf6a63e97243afbf550fee7359f2e87.svg";